import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Text, TextButton } from '@wix/design-system';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { useBreakpoint } from 'providers/BreakpointProvider';
import { faqSubtitleMap } from '../../constants';
import s from './Faq.scss';
import { Language, Experiments, MediaDevices } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';

const newSupportLinkLangs = new Set([
  Language.EN,
  Language.ES,
  Language.PT,
  Language.FR,
  Language.DE,
  Language.RU,
  Language.IT,
  Language.JA,
  Language.KO,
  Language.TR,
  Language.PL,
  Language.NL,
]);
interface SubtitleProps {
  rootStore: RootStore;
}
const FaqSideSubtitleComp: React.FC<SubtitleProps> = (props: SubtitleProps) => {
  const { currentBreakpoint } = useBreakpoint();
  const isMobile = currentBreakpoint === MediaDevices.Mobile;
  const isMobileTrustEnabled = props.rootStore.appStore.experiments[Experiments.MobileTrust] === 'true';
  const isCompact = isMobile && isMobileTrustEnabled;
  const { t } = useTranslation();
  const { theme } = usePageModeContext();
  const { isDayful } = props.rootStore.appStore;
  const { locale, siteGuid } = props.rootStore.appStore.appContext;
  const useChatbotLink = newSupportLinkLangs.has(locale as Language);
  const contactLink = isDayful
    ? 'faq_section.faq_subtitle_support_contact_dayful'
    : useChatbotLink
    ? 'faq_section.faq_subtitle_support_contact_dynamic'
    : 'faq_section.faq_subtitle_support_contact';
  const supportLink = isDayful
    ? 'faq_section.faq_subtitle_support_link_dayful'
    : 'faq_section.faq_subtitle_support_link';
  return (
    <div className={s.subtitle}>
      <Text
        weight={isCompact ? 'thin' : 'normal'}
        size={isCompact ? 'small' : 'medium'}
        tagName='p'
      >
        {t('faq_section.faq_subtitle')}{' '}
        <span>
          <Trans i18nKey={faqSubtitleMap[theme].faqSubtitle}>
            {faqSubtitleMap[theme].faqSubtitle}
            <TextButton
              as='a'
              size={isCompact ? 'small' : 'medium'}
              target='_blank'
              href={t(supportLink)}
            >
              faq_section.faq_subtitle_support_link
            </TextButton>
            <TextButton
              as='a'
              size={isCompact ? 'small' : 'medium'}
              target='_blank'
              dataHook='contact-us'
              data-testid='contact-us'
              href={t(contactLink, { siteGuid })}
            >
              faq_section.faq_subtitle_support_contact
            </TextButton>
          </Trans>
        </span>
      </Text>
    </div>
  );
};

export const FaqSideSubtitle = withInjectedRootStore(FaqSideSubtitleComp);
